var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vehicule-form',{attrs:{"title":_vm.title},on:{"submitVehiculeForm":_vm.onSubmit,"submitVehiculeFormAndPrintEtiquette":_vm.onSubmitAndPrint}})}
var staticRenderFns = []

export { render, staticRenderFns }